import { BuilderJSON } from 'store';
import { AsideContentItem } from '../..';
import { BuilderColorPicker } from 'pages/storebuilder/components/forms/colorpicker';
import { BuilderUploadImage } from 'pages/storebuilder/components/forms/upload';
import { BuilderTextField } from 'pages/storebuilder/components/forms/input';

export const CarouselStyle = ({ title }) => {
  const {
    pages,
    setCarouselSectionBackgroundColor,
    setCarouselSectionBackgroundImage,
    setCarouselSectionForegroundColor,
    setCarouselSectionOverlayBackgroundColor,
    setCarouselSectionOverlayOpacity,
    setCarouselSectionMarginTop,
    setCarouselSectionMarginBottom,
    setCarouselSectionPaddingTop,
    setCarouselSectionPaddingBottom
  } = BuilderJSON((state) => state);
  const { style } = pages?.landing?.carouselSections?.filter(
    (sec) => sec?.title === title
  )[0];

  return (
    <>
      <AsideContentItem label={`Background`}>
        <div className={`builder_items`}>
          <BuilderColorPicker
            title={title}
            label={`Color`}
            activeColor={style?.backgroundColor}
            handleActiveColor={setCarouselSectionBackgroundColor}
          />
          <BuilderUploadImage
            title={title}
            label={`Image`}
            mediaRecommendations={`Recommended dimensions are 1600 x 750, types are jpg, jpeg, png, gif or svg`}
            defaultImage={style?.backgroundImage}
            setImage={setCarouselSectionBackgroundImage}
          />
        </div>
      </AsideContentItem>
      <AsideContentItem label={`Foreground`}>
        <div className={`builder_items`}>
          <BuilderColorPicker
            title={title}
            label={`Color`}
            activeColor={style?.foregroundColor}
            handleActiveColor={setCarouselSectionForegroundColor}
          />
        </div>
      </AsideContentItem>
      <AsideContentItem label={`Overlay`}>
        <div className={`builder_items`}>
          <BuilderColorPicker
            title={title}
            label={`Background`}
            activeColor={style?.overlayBackgroundColor}
            handleActiveColor={setCarouselSectionOverlayBackgroundColor}
          />
          <BuilderTextField
            type={`number`}
            label={`Opacity`}
            defaultValue={style?.overlayOpacity}
            onChange={(e) => {
              setCarouselSectionOverlayOpacity(e?.target?.value, title);
            }}
          />
        </div>
      </AsideContentItem>
      <AsideContentItem label={`Section spaces`}>
        <div className={`builder_items`}>
          <BuilderTextField
            type={`number`}
            label={`Margin top`}
            defaultValue={style?.marginTop}
            onChange={(e) => {
              setCarouselSectionMarginTop(e?.target?.value, title);
            }}
          />
          <BuilderTextField
            type={`number`}
            label={`Margin bottom`}
            defaultValue={style?.marginBottom}
            onChange={(e) => {
              setCarouselSectionMarginBottom(e?.target?.value, title);
            }}
          />
          <BuilderTextField
            type={`number`}
            label={`Padding top`}
            defaultValue={style?.paddingTop}
            onChange={(e) => {
              setCarouselSectionPaddingTop(e?.target?.value, title);
            }}
          />
          <BuilderTextField
            type={`number`}
            label={`Padding bottom`}
            defaultValue={style?.paddingBottom}
            onChange={(e) => {
              setCarouselSectionPaddingBottom(e?.target?.value, title);
            }}
          />
        </div>
      </AsideContentItem>
    </>
  );
};
